import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SectorService } from '../sector.service';

@Component({
  selector: 'app-create-sector',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule],
  templateUrl: './create-sector.component.html'
})
export class CreateSectorComponent implements OnDestroy, OnInit {
  @Input() id!: number | null;
  form!: FormGroup;
  @Output() formSubmitted = new EventEmitter<void>();
  @Output() modalClosed = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private sectorService: SectorService
  ) {}

  ngOnDestroy(): void {
    this.modalClosed.emit();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      description: ['', Validators.required]
    });
    if (this.id) {
      this.getData();
    }
  }

  getData(): void {
    this.sectorService.getById(this.id as number).subscribe({
      next: res => this.form.patchValue(res.data)
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched) : false;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        this.form.get(key)?.markAsTouched();
      });
      return;
    }
    if (this.id) {
      this.sectorService.update(this.id, this.form.value).subscribe({
        next: () => this.formSubmitted.emit()
      });
    } else {
      this.sectorService.create(this.form.value).subscribe({
        next: () => this.formSubmitted.emit()
      });
    }
  }
}
